//ctext

import React from "react";
import { Dimensions, StyleSheet, Text } from "react-native";
import { COLORS, FONTS } from "../constant";
import { CONSTANTS } from "../utilities/Dimensions";
const isSmallDevice = Dimensions.get("window").width < 767;

const styles = StyleSheet.create({
  inputLabel: {
    ...FONTS.fontSemi,
    fontSize: CONSTANTS.FONTSIZES.DESK18,
    color: COLORS.darkGray,
    letterSpacing: 0,
  },
  inputError: {
    ...FONTS.fontSemi,
    fontSize: CONSTANTS.FONTSIZES.DESK18,
    color: COLORS.red,
  },
  otpTitle: {
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: "bold",
    fontStyle: "normal",
    lineHeight: 21,
    letterSpacing: 0.64,
    textAlign: "center",
    color: "#66625f",
    paddingTop: 20,
  },
  otpDesc: {
    opacity: 0.5,
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: "500",
    fontStyle: "normal",
    lineHeight: 16,
    letterSpacing: 0,
    textAlign: "center",
    color: "#02122c",
    paddingTop: 10,
    marginHorizontal: 60,
    width: 233,
  },
  otherServicesTitle: {
    fontFamily: FONTS.InterBold,
    fontSize: 23,
    color: COLORS.charcoalTwo,
    ineHeight: 30,
  },

  usedCarLoanHeader: {
    fontFamily: FONTS.InterBold,
    fontSize: 28,
    color: COLORS.charcoal,
  },
  usedCarLoanIntro: {
    fontFamily: FONTS.Inter,
    fontSize: 14,
    color: COLORS.darkBlueGrey,
  },
  usedCarLoanUpto: {
    fontFamily: FONTS.Inter,
    fontSize: 12,
    color: COLORS.mediumGrey,
  },
  basicInformation: {
    fontFamily: FONTS.InterSemiBold,
    fontSize: 18,
    color: COLORS.darkBlack,
  },
  basicInformationSubHeader: {
    fontFamily: FONTS.InterSemiBold,
    fontSize: 16,
    color: COLORS.black,
  },
  headerDesc: {
    fontFamily: FONTS.InterBold,
    fontSize: 12,
    color: COLORS.black,
    opacity: 0.8,
    lineHeight: 18,
  },
  inputTopLabel: {
    fontFamily: FONTS.Inter,
    fontSize: 12,
    color: "#757575",
  },

  backNavigationText: {
    fontFamily: FONTS.InterMedium,
    fontSize: 12,
    color: COLORS.darkBlack,
    lineHeight: 21,
    letterSpacing: 0.5,
  },
  statusTitle: {
    fontFamily: FONTS.InterBold,
    fontSize: 15,
    letterSpacing: -0.3,
    textAlign: "center",
    color: COLORS.black,
  },
  serviceDesc: {
    fontFamily: FONTS.Inter,
    fontSize: 10,
    textAlign: "left",
    color: COLORS.charcoalTwo,
  },
  loanAppCardTitle: {
    fontFamily: FONTS.Inter,
    fontSize: 10,
    lineHeight: 24,
    letterSpacing: 0,
    color: "#02122c",
  },
  loanAppCardIdValue: {
    fontFamily: FONTS.InterMedium,
    fontSize: 10,
    color: "#02122c",
  },
  loanAppCardStatusValue: {
    fontFamily: FONTS.InterSemiBold,
    fontSize: 10,
    lineHeight: 24,
    letterSpacing: 0,
    color: "#02122c",
  },
  kycDesc: {
    fontFamily: FONTS.Inter,
    fontSize: 11,
    opacity: 0.6,
    color: COLORS.black,
    display: "flex",
    alignItems: "center",
  },
  kycTypeText: {
    fontFamily: FONTS.InterBold,
    fontSize: 14,
    color: COLORS.red,
  },
  tripBenifitText: {
    fontFamily: FONTS.Inter,
    fontSize: 14,
    color: COLORS.warmGrey2,
  },
  certificateText: {
    fontFamily: FONTS.InterMedium,
    fontSize: 13,
    color: COLORS.orange,
    paddingTop: 10,
  },
  transactionText: {
    fontFamily: FONTS.InterMedium,
    fontSize: 13,
    color: COLORS.navyBlue,
    paddingTop: 10,
  },
  historyText: {
    fontFamily: FONTS.InterMedium,
    fontSize: 13,
    color: COLORS.yellow,
    paddingTop: 10,
  },
  policyNbrText: {
    fontFamily: FONTS.InterBold,
    fontSize: 17,
    color: COLORS.white,
  },
  mobileDescTextStyle: {
    opacity: 0.6,
    fontFamily: FONTS.InterMedium,
    fontSize: 11,
    color: COLORS.black,
  },
  noteTextStyle: {
    fontFamily:FONTS.InterMedium,
    fontSize: 15,
    color: "#343434",
  },
  benifitHeaderTextStyle: {
    fontFamily:FONTS.InterSemiBold,
    fontSize: 9,
    color: "#212820",
  },
  benifitTextStyle: {
    fontFamily:FONTS.InterMedium,
    fontSize: 11,
    color: "#707070",
  },
  benifitPlanHeadingTextStyle: {
    fontFamily:FONTS.InterBold,
    fontSize: 15,
  },
  cancelPolicyConfirmTextStyle: {
    color:"#02122c",
    opacity:0.8,
    fontFamily:FONTS.InterBold,
    fontSize: 14,
  },
  disputeHeaderTextStyle: {
    width: "auto",
    maxWidth:200,
    height: 60,
    minWidth: 150,
    paddingHorizontal: 10,
    marginVertical: 5,
    fontFamily: FONTS.InterBold,
    fontSize: 13,
    color: "#66625f",
    paddingTop: 10,
    textAlign:"center"
  },
  certificateHeadlineStyle:{
    fontSize:12,
    fontFamily:FONTS.InterBold,
    color:"#25243b"
  },
  disputeCountTextStyle:{
    fontSize:12,
    fontFamily:FONTS.InterMedium,
    color:"#677180"
  },
  closurePolicyText: {
    fontFamily:FONTS.Inter,
    fontSize: 16,
    color:COLORS.white
  },
  benifitTextStyle: {
    fontFamily:FONTS.InterMedium,
    fontSize: 11,
    color: "#707070",
  },
  benifitPlanHeadingTextStyle: {
    fontFamily:FONTS.InterBold,
    fontSize: 15,
  },
  fontBrown: {
    fontFamily:FONTS.Inter,
    fontSize: 12,
    color:COLORS.brownishGrey
  },
  vrnTextStyle:{
    fontFamily:FONTS.InterBold,
    fontSize: 12,
    color: COLORS.black,
  },
  vehicleModalStyle:{
    fontFamily:FONTS.Inter,
    fontSize: 9,
    color: COLORS.black,
    opacity:0.6
  },
  priceTextStyle:{
    fontFamily:FONTS.InterBold,
    fontSize: 11,
    color: COLORS.red,
    marginBottom:4
  },
  headerTextStyle:{
    fontFamily:FONTS.InterBold,
    fontSize: 15,
    color: COLORS.black,
  },
  dropDownHeaderTextStyle:{
    fontFamily:FONTS.Inter,
    fontSize: 14,
    color:'rgba(37, 36, 59, 0.6)',
  },
  labelStyle: {
    fontFamily: FONTS.Inter,
    fontWeight: "500",
    fontSize:14,
    paddingTop:5,
    flex: '0.5',
    color: '#757575',
  },
  warningHeaderStyle: {
    fontFamily: FONTS.InterBold,
    fontSize:15,
    color: COLORS.brownishGrey,
  },
  tagWarningTextStyle:{
    fontFamily: FONTS.InterBold,
    fontWeight: "600",
    fontSize:14,
    color:COLORS.maroon,
    marginVertical:8
  },
  tagWarningDescStyle:{
    fontFamily: FONTS.Inter,
    fontWeight: "500",
    fontSize:11,
    color:COLORS.black,
    opacity:0.6,
    width:'60%',
    paddingLeft:5
  },
  searchTextStyle:{
    fontFamily: FONTS.Inter,
    fontWeight: "500",
    fontSize:13,
    color:'#677180',
  },
  modalTitleStyle:{
    fontFamily: FONTS.InterBold,
    fontWeight: "500",
    fontSize:14,
    color:COLORS.black,
  },
  modalMsgStyle: {
    color: COLORS.black,
    fontFamily: FONTS.Inter,
    fontSize: 13,
    opacity: 0.8,
    marginBottom: 10,
    paddingHorizontal: 15,
    textIndent:-5,
    lineHeight:18
},
modalFooterLinkStyle: {
  fontFamily: FONTS.InterBold,
  fontSize: 12,
  letterSpacing: -0.22,
  color: "#9d1d27",
  textAlign:'center'
},
paymentLogoTextStyle: {
  fontFamily: FONTS.Inter,
  fontSize: 14,
  color: COLORS.white,
  width:'40%',
  textIndent:-5,
  paddingLeft:20,
  paddingTop:20
},
newTextStyle: {
  fontFamily: FONTS.Inter,
  fontSize: 10,
  color: COLORS.white,
  textTransform:'uppercase'
},
AutoRechargeTextStyle:{
  fontFamily: FONTS.InterBold,
  fontSize: 18,
  color: COLORS.brownishGrey,
  paddingVertical:8
},
AutoRechargeTextDescStyle:{
  width:'75%',
  fontFamily: FONTS.Inter,
  fontSize: 13,
  color: COLORS.brownishGrey,
  paddingVertical:3,
  textIndent:-5,
  paddingLeft:5,
},
FundTransferTextStyle:{
  fontFamily: FONTS.InterBold,
  fontSize: 18,
  color: COLORS.white,
  paddingVertical:8
},
FundTransferTextDescStyle:{
  width:'75%',
  fontFamily: FONTS.Inter,
  fontSize: 13,
  color: COLORS.white,
  paddingVertical:3,
  textIndent:-5,
  paddingLeft:5,
},
vehicleNbrStyle:{
  fontFamily: FONTS.InterBold,
  fontSize: 14,
  color: COLORS.black200,
  marginBottom:3,
  fontWeight:'600'
},
rupeeSymbolStyle:{
  fontFamily: FONTS.InterBold,
  fontSize: 19,
  color: COLORS.maroon,
},
enterOtpTextStyle:{
  fontFamily: FONTS.InterBold,
  fontSize: 14,
  color: COLORS.black,
  textAlign:'center',
  marginTop:15
},
otpDescTextStyle: {
  opacity: 0.5,
  fontFamily: "Inter",
  fontSize: 14,
  fontWeight: "500",
  textAlign: "center",
  color: COLORS.black,
  paddingTop: 10,
  marginHorizontal: 30,
  marginBottom:20
},
timerTextStyle: {
  opacity: 0.5,
  fontFamily: "Inter",
  fontSize: 12,
  color: COLORS.black
},
resendTextStyle: {
  fontFamily: "Inter",
  fontSize: 12,
  lineHeight: 15,
  color: COLORS.red
},
bulletTextStyle: {
  fontFamily: "Inter",
  fontSize: 12,
  color: COLORS.black,
  marginBottom:5
},
verifyTextStyle: {
  fontFamily: FONTS.InterBold,
  fontSize: 14,
  color: COLORS.red,
},
verifiedTextStyle: {
  fontFamily: FONTS.InterBold,
  fontSize: 14,
  color: COLORS.green,
},
mpdetailsText: {
  fontFamily: FONTS.InterBold,
  fontSize: 14,
  color: COLORS.black,
  textIndent:-5
},
mpdetailsLink: {
  fontFamily: FONTS.Inter,
  fontSize: 12,
  color: COLORS.blue200,
  marginTop:24,
  textDecorationLine:'underline',
},
mpLowbalance: {
  fontFamily: FONTS.InterBold,
  fontSize: 14,
  color: COLORS.black300,
  fontWeight:'bold'
},
mpMinbalance: {
  fontFamily: FONTS.Inter,
  fontSize: 15,
  color: 'rgba(28, 25, 57, 0.8)',
  marginTop:20,
  lineHeight:22
},
mpHeaderTextStyle: {
  fontFamily: FONTS.InterSemiBold,
  fontSize: 14,
  color: COLORS.black400,
  marginHorizontal:10,
  fontWeight:'600'
},
mpbenefitTextStyle: {
  fontFamily: FONTS.Inter,
  fontSize: 13,
  color: COLORS.black,
  marginHorizontal:10,
},
mpTitleTextStyle: {
  fontFamily: FONTS.InterSemiBold,
  fontSize: 22,
  color: COLORS.white,
  marginBottom:6
},
mpTitleTextStyleYellow: {
  fontFamily: FONTS.InterSemiBold,
  fontSize: 22,
  color: COLORS.yellow300,
},
mpTextStyleYellow: {
  fontFamily: FONTS.InterSemiBold,
  fontSize: 13,
  color: COLORS.yellow300,
},
mpTermsTextStyle: {
  fontFamily: FONTS.InterSemiBold,
  fontSize: 13,
  color: COLORS.white,
  paddingTop:8,
  textDecorationLine:'underline'
},
mpYearTextStyle: {
  fontFamily: FONTS.InterBold,
  fontSize: 20,
  color: COLORS.white,
  marginTop:10
},
mpHeaderDescStyle:{
  fontFamily: FONTS.Inter,
  fontSize: 14,
  color: COLORS.warmGrey1,
  marginLeft:26
},
ucltandcItSm: {
  ontFamily: FONTS.InterBold,
  fontStyle: "italic",
  fontSize: 11,
  color: COLORS.black
},
ucltandcBold: {
  fontFamily: FONTS.InterBold,
  fontSize: 12,
  color: COLORS.black
},
sideNavText: { fontFamily: FONTS.Inter, fontSize: 15, color: '#a0a0a0', paddingTop: 5 },
sideNavTextActive: { fontFamily: FONTS.Inter, fontSize: 15, color: COLORS.white },
optOutConfirmTextStyle:{
  fontFamily: FONTS.InterBold,
  fontSize: 14,
  color: COLORS.red200,
  textAlign:'center'
},
tncTextStyle:{ 
  fontFamily: FONTS.Inter,
  fontSize: 11,
  color: COLORS.black,
  marginVertical: 5, 
  marginBottom: 20 
},
tripInsRefTextStyle:{
  fontFamily: FONTS.Inter,
  fontSize: 13,
  color: COLORS.black400,
  opacity:0.6
},
tripInsPlanDescStyle:{
  fontFamily: FONTS.Inter,
  fontSize: 12,
  color: COLORS.black400,
  display:'flex',
  alignItems:'center'
},
updateKycTextStyle:{
  fontFamily: "Inter",
  fontSize: 19,
  fontWeight: "bold",
  fontStyle: "normal",
  lineHeight: 23,
  letterSpacing: 0.38,
  textAlign: "center",
  color: "#bd2d37",
  paddingLeft: 15,
},
srDateStyle:{
  fontFamily: "Inter",
  fontSize: 11,
  color: COLORS.gray250,
  fontWeight:'bold'
},
srStatusStyle:{
  fontFamily: "Inter",
  fontSize: 17,
  color: COLORS.black450,
  fontWeight:'bold',
  paddingVertical:8
},
srReqIdStyle:{
  fontFamily: "Inter",
  fontSize: 11,
  color: COLORS.gray250,
  fontWeight:'500'
},
//loginstyle
loginText:{
  fontSize: 18.4,
  fontWeight: "normal",
  fontStyle: "normal",
  lineHeight: 22.1,
  letterSpacing: 0,
  textAlign: "center",
  color: COLORS.white,
},
signInText: {
  fontFamily: "Inter",
  fontSize: 14,
},
labelStyle: {
  fontFamily: "Inter",
  fontSize: 8,
  fontWeight: "normal",
  fontStyle: "normal",
  lineHeight: 10,
  letterSpacing: 0,
  textAlign: "left",
  color: "blue",
},
inputLabelStyle: {
  fontFamily: FONTS.Inter,
  fontWeight: "500",
  fontSize:14,
  paddingTop:5,
  flex: '0.5',
  color: '#757575',
},
textStyleForgot: {
  fontFamily: "Inter",
  fontSize: 11,
  fontWeight: 400,
  color: COLORS.blue500,
},
captchaText: {
  fontStyle: "italic",
  fontSize: 18,
  fontFamily: "auto",
  letterSpacing: 8,
  textAlign: "center",
 
},
loginBtmText: {
  fontFamily: "Inter",
  fontSize: isSmallDevice ? 12 : 15,
  lineHeight: 17,
  textAlign: "left",
  color:COLORS.gray700,
 
},
loginHereText: {
  fontFamily: "Inter",
  fontSize: isSmallDevice ? 12 : 15,
  lineHeight: 17,
  letterSpacing: 0,
  textAlign: "left",
  color:COLORS.red700,
},
enterOtpDescStyle: {
  textAlign: "center",
  fontFamily: "Inter",
  fontSize: 14,
  fontWeight: "500",
  fontStyle: "normal",
  lineHeight: 12,
  letterSpacing: 0,
  color: "#02122c",
 
},
activeCapchaStyle:{
  fontStyle: "italic",
  fontFamily: "auto",
  letterSpacing: 4,
  textAlign: "center",

},
enterOtpTxtStyle: {
  color: COLORS.darkGray,
  fontFamily: "Inter",
  fontSize: 18,
  fontWeight: "600",
},
checkTaglabelStyle: {
  fontFamily: "Inter",
  fontSize: 19,
  fontWeight: "normal",
  fontStyle: "normal",
  lineHeight: 13,
  letterSpacing: 0.33,
  textAlign: "left",
  color: COLORS.darkGray,
 
},
checkTagSubmitStyle: {
  fontFamily: "Inter",
  fontSize: 12,
  fontWeight: "bold",
  fontStyle: "normal",
  lineHeight: 14,
  letterSpacing: -0.24,
  textAlign: "left",
  color:COLORS.white,
},
checkOtpDesc:{
  fontFamily: "Inter",
  fontSize: 15,
  fontWeight: "normal",
  fontStyle: "normal",
  lineHeight: 20,
  letterSpacing: 0.45,
  textAlign: "center",
  color:COLORS.darkGray,
},
tagBalanceDescStyle: {
  fontFamily: "Inter",
  fontSize: 19,
  fontWeight: "500",
  fontStyle: "normal",
  lineHeight: 28,
  letterSpacing: 0.76,
  textAlign: "center",
  color:COLORS.darkGray,
},
tagBalanceAmountStyle: {
  fontFamily: "Inter",
  fontWeight: "normal",
  fontStyle: "normal",
  lineHeight: 57,
  letterSpacing: 0,
  textAlign: "center",
  color: "#3ABF10",
  paddingTop: "10%",
  fontSize: 24,
},
forgetPwHeader:{
  fontWeight: "600",
  fontSize: 18,
  color:COLORS.darkGray,
  fontFamily: "Inter",
},
forgetNewPw:{
  textAlign: "center",
  alignSelf: "center",
  fontFamily: "Inter",
  fontSize: 15,
  fontWeight: "bold",
  fontStyle: "normal",
  lineHeight: 13,
  letterSpacing: 0.48,
  color:COLORS.darkGray,
},
forgetPw:{
  color: "#02122c",
  opacity: 0.6,
},
helperTxtErrorStyle: {
  fontFamily: "Inter",
  fontSize: 8,
  fontWeight: "500",
  fontStyle: "normal",
  lineHeight: 9,
  letterSpacing: 0,
  textAlign: "left",
  color: "red",
},
helperTxtStyle:{
  fontFamily: "Inter",
  fontSize: 8,
  fontWeight: "500",
  fontStyle: "normal",
  lineHeight: 9,
  letterSpacing: 0,
  textAlign: "left",
  paddingTop: 3,
  color:"red"
},
PoolEditBtn:{
  fontFamily: "Inter",
  fontSize: 13,
  fontWeight: "500",
  fontStyle: "normal",
  lineHeight: 14,
  letterSpacing: 0,
  textAlign: "left",
  color: "#cb0303",
},
CCardStyle:{
  fontFamily: "Inter",
  fontSize: 9,
  fontWeight: "500",
  fontStyle: "normal",
  letterSpacing: 0.18,
  textAlign: "left",
  color: "#02122c",

},
MaskCard:{
 fontFamily: "Inter",
 fontSize: 9,
 fontWeight: "500",
 fontStyle: "normal",
 letterSpacing: 0.18,
 textAlign: "left",
 color: "#02122c",
 
},
viewVehicleTextStyle:{
  fontFamily: "Inter",
  fontSize: 13,
  fontWeight: "normal",
  fontStyle: "normal",
  lineHeight: 15,
  letterSpacing: 0,
  textAlign: "left",
  color: "#999999",
  
},
headingTextStyle: {
  fontFamily: "Inter",
  fontSize: 15,
  fontWeight: "500",
  fontStyle: "normal",
  letterSpacing: 0.3,
  textAlign: "left",
  color: "#5f5f5f",

},
cardNUmberTextStyle:{
  fontFamily: "Inter",
  fontSize: 13,
  fontWeight: "normal",
  fontStyle: "normal",
  lineHeight: 15,
  letterSpacing: 0,
  textAlign: "left",
  color: "#02122c",
},
poolAcTextStyle: {
  opacity: 0.6,
  fontFamily: "Inter",
  fontSize: 10,
  fontWeight: "500",
  fontStyle: "normal",
  lineHeight: 12,
  letterSpacing: 0,
  textAlign: "left",
  color: "#02122c",
},
amountTextStyle: {
  fontFamily: "Inter",
  fontSize: 15,
  fontWeight: "bold",
  fontStyle: "normal",
  lineHeight: 18,
  letterSpacing: 0,
  textAlign: "left",
  color: "#02122c",
},
qabInnerText: {
  fontFamily: "Inter",
  fontSize: 10,
  color: "#9b1e27",
},
PoolText:{
  fontFamily: "Inter",
  fontSize: 10,
  fontWeight: "500",
 fontStyle: "normal",
  letterSpacing: 0.2,
  textAlign: "center",
 color: "#c2c2c2",
 
},
paymentMethodTextStyle: {
  fontFamily: "Inter",
  fontSize: 12,
  fontWeight: "normal",
  fontStyle: "normal",
  letterSpacing: 0,
  textAlign: "left",
  color: "#02122c",
},
selectCCstyle:{
  fontFamily: "Inter",
  fontSize: 14,
  fontWeight: "500",
  fontStyle: "normal",
  letterSpacing: 0,
  textAlign: "center",
  color: "#02122c",
},
selectedChasisTextStyle:{
  fontFamily: "Inter",
  fontSize: 14,
  fontWeight: "normal",
  fontStyle: "normal",
  lineHeight: 16.8,
  letterSpacing: 0,
  textAlign: "left",
  color: "#02122c",
},
fastagIdTextStyle:{
  fontFamily: "Inter",
  fontSize: 11,
  fontWeight: "500",
  lineHeight: 13.2,
  letterSpacing: 0,
  textAlign: "left",
  color: "#02122c",
},
changeVehicleTextStyle:{
  textDecorationLine: "underline",
  fontFamily: "Inter",
  fontSize: 9,
  lineHeight: 10.9,
  letterSpacing: 0.27,
  textAlign: "left",
  color: "#757575",
  marginTop:5
},
creditCardTitleStyle:{
  fontFamily: "Inter",
  fontSize: 9,
  fontWeight: "500",
  fontStyle: "normal",
  letterSpacing: 0.18,
  textAlign: "left",
  color: "#02122c",
},
cardNumberStyle:{
  opacity: 0.6,
  fontFamily: "Inter",
  fontSize: 9,
  fontWeight: "500",
  fontStyle: "normal",
  letterSpacing: 0.18,
  textAlign: "left",
  color: "#02122c",
  paddingTop: 10,
},
editTextStyle:{
  fontFamily: "Inter",
  fontSize: 13,
  fontWeight: "500",
  fontStyle: "normal",
  lineHeight: 14,
  letterSpacing: 0,
  textAlign: "left",
  color: "#cb0303",
},
selectNumberTextStyle:{
  fontFamily: "Inter",
  fontSize: 10,
  fontWeight: "500",
  fontStyle: "normal",
  letterSpacing: 0.2,
  textAlign: "center",
  color: "#c2c2c2",
  paddingTop: 10,
},
maskedCardNumberStyle:{
  opacity: 0.6,
  fontFamily: "Inter",
  fontSize: 9,
  fontWeight: "500",
  fontStyle: "normal",
  letterSpacing: 0.18,
  textAlign: "left",
  color: "#02122c",
  paddingTop: 10,
},
creditCardTextStyle:{
  fontFamily: "Inter",
  fontSize: 9,
  fontWeight: "500",
  fontStyle: "normal",
  letterSpacing: 0.18,
  textAlign: "left",
  color: "#02122c",
},
closeTextStyle:{margin:15,marginBottom:0,color:"#bd2d37",fontFamily:"Inter"},
selecARTextStyle:{
  fontFamily: "Inter",
  fontSize: 14,
  fontWeight: "500",
  fontStyle: "normal",
  letterSpacing: 0,
  textAlign: "center",
  color: "#02122c",
},
updateTextStyle:{
  fontFamily: "Inter",
  fontSize: 13,
  fontWeight: "bold",
  fontStyle: "normal",
  lineHeight: 18,
  letterSpacing: 0.08,
  textAlign: "left",
  color: "#9c1d25",
},
getOtpTextStyle:{
  fontFamily: "Inter",
  fontSize: 13,
  fontWeight: "bold",
  fontStyle: "normal",
  lineHeight: 18,
  letterSpacing: 0.08,
  textAlign: "left",
  color: "#3ABF10",
},
adrsTextStyle:{
  fontFamily: "Inter",
  fontSize: CONSTANTS.FONTSIZES.DESK18,
  fontWeight: "bold",
  fontStyle: "normal",
  color: "#a7a7a7",
},
updatePicTextStyle:{
  fontFamily: "Inter",
  fontSize: isSmallDevice ? 7 : 12,
  fontWeight: "bold",
  fontStyle: "normal",
  lineHeight: 14,
  letterSpacing: 0.24,
  textAlign: "center",
  color: "#ffffff",
},
tranxnTextStyle:{
  fontFamily: "Inter",
  fontSize: 13,
  fontWeight: "bold",
  fontStyle: "normal",
  lineHeight: 26,
  letterSpacing: 0,
  textAlign: "left",
  color: "#66625f",
  flex: 1,
  width: 160, 
  minWidth: 150 
},
smsTextStyle:{
  fontFamily: "Inter",
  fontSize: 13,
  lineHeight: 15,
  letterSpacing: 0,
  textAlign: "center",
  color: "#02122c",
  paddingTop: 15
},
welcomeModalDescText:{
  fontFamily: "Inter",
  fontSize: 11,
  fontWeight: "500",
  color: "#fff",
},
welcomeModalTitle:{
  fontFamily: "Inter",
  fontSize: 15,
  fontWeight: "500",
  color: "#fff",
  lineHeight:20,
  width:'84%',
},
npciMarkedTitleStyle:{
  fontFamily: "Inter",
  fontSize: 20,
  fontWeight: "600",
  color: "#fff",
  lineHeight:26,
  marginBottom:20
},
npciMarkedDescStyle:{
  fontFamily: "Inter",
  fontSize: 14,
  fontWeight: "500",
  color: "#fff",
  lineHeight:20,
},
npciMarkedVehListTitleStyle:{
  fontFamily: "Inter",
  fontSize: 15,
  fontWeight: "600",
  color: COLORS.black,
},
npciMarkedVehListDescStyle:{
  fontFamily: "Inter",
  fontSize: 13,
  fontWeight: "300",
  color: COLORS.black,
  lineHeight:18,
  marginTop:5
},
markedForCloseTextStyle:{
  // fontFamily: FONTS.fontPoppins,
  fontSize: 9,
  fontWeight: "300",
  color: '#ff9006',
},


});


const selectCCstyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.selectCCstyle, ...otherProps.style }}>{children}</Text>
));

const paymentMethodTextStyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.paymentMethodTextStyle, ...otherProps.style }}>{children}</Text>
));

const PoolText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.PoolText, ...otherProps.style }}>{children}</Text>
));
const qabInnerText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.qabInnerText, ...otherProps.style }}>{children}</Text>
));

const amountTextStyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.amountTextStyle, ...otherProps.style }}>{children}</Text>
));
const poolAcTextStyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.poolAcTextStyle, ...otherProps.style }}>{children}</Text>
));
const cardNUmberTextStyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.cardNUmberTextStyle, ...otherProps.style }}>{children}</Text>
));


const headingTextStyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.headingTextStyle, ...otherProps.style }}>{children}</Text>
));

const viewVehicleTextStyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.viewVehicleTextStyle, ...otherProps.style }}>{children}</Text>
));


const MaskCard = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.MaskCard, ...otherProps.style }}>{children}</Text>
));

const CCardStyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.CCardStyle, ...otherProps.style }}>{children}</Text>
));
const PoolEditBtn = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.PoolEditBtn, ...otherProps.style }}>{children}</Text>
));
const inputLabel = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.inputLabel, ...otherProps.style }}>{children}</Text>
));
const tripBenifitText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.tripBenifitText, ...otherProps.style }}>
    {children}
  </Text>
));
const inputError = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.inputError, ...otherProps.style }}>{children}</Text>
));
const otpTitle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.otpTitle, ...otherProps.style }}>{children}</Text>
));
const otpDesc = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.otpDesc, ...otherProps.style }}>{children}</Text>
));
const usedCarLoanHeader = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.usedCarLoanHeader, ...otherProps.style }}>
    {children}
  </Text>
));
const usedCarLoanIntro = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.usedCarLoanIntro, ...otherProps.style }}>
    {children}
  </Text>
));
const usedCarLoanUpto = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.usedCarLoanUpto, ...otherProps.style }}>
    {children}
  </Text>
));
const serviceDesc = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.serviceDesc, ...otherProps.style }}>{children}</Text>
));
const otherServicesTitle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.otherServicesTitle, ...otherProps.style }}>
    {children}
  </Text>
));
const basicInformation = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.basicInformation, ...otherProps.style }}>
    {children}
  </Text>
));
const basicInformationSubHeader = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.basicInformationSubHeader, ...otherProps }}>
    {children}
  </Text>
));
const headerDesc = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.headerDesc, ...otherProps.style }}>{children}</Text>
));
const inputTopLabel = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.inputTopLabel, ...otherProps.style }}>
    {children}
  </Text>
));
const backNavigationText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.backNavigationText, ...otherProps.style }}>
    {children}
  </Text>
));
const statusTitle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.statusTitle, ...otherProps }}>{children}</Text>
));
const loanAppCardTitleText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.loanAppCardTitle, ...otherProps.style }}>
    {children}
  </Text>
));
const loanAppCardIdValueText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.loanAppCardIdValue, ...otherProps.style }}>
    {children}
  </Text>
));
const loanAppCardStatusValueText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.loanAppCardStatusValue, ...otherProps.style }}>
    {children}
  </Text>
));
const kycDesc = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.kycDesc, ...otherProps.style }}>{children}</Text>
));
const kycTypeText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.kycTypeText, ...otherProps.style }}>{children}</Text>
));
const sideNavText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.sideNavText, ...otherProps.style }}>{children}</Text>))
const sideNavTextActive = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.sideNavTextActive, ...otherProps.style }}>{children}</Text>))
const certificateText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.certificateText, ...otherProps.style }}>
    {children}
  </Text>
));
const transactionText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.transactionText, ...otherProps.style }}>
    {children}
  </Text>
));
const historyText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.historyText, ...otherProps.style }}>{children}</Text>
));
const policyNbrText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.policyNbrText, ...otherProps.style }}>
    {children}
  </Text>
));
const mobileDescText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.mobileDescTextStyle, ...otherProps.style }}>
    {children}
  </Text>
));
const inputNoteText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.noteTextStyle, ...otherProps.style }}>
    {children}
  </Text>
));
const benifitHeaderText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.benifitHeaderTextStyle, ...otherProps.style }}>
    {children}
  </Text>
));
const benifitText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.benifitTextStyle, ...otherProps.style }}>
    {children}
  </Text>
));
const benifitPlanHeadingText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.benifitPlanHeadingTextStyle, ...otherProps.style, }}>
    {children}
  </Text>
));
const cancelPolicyConfirmText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.cancelPolicyConfirmTextStyle, ...otherProps.style, }}>
    {children}
  </Text>
));
const tiTransactionText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.disputeHeaderTextStyle, ...otherProps.style, }}>
    {children}
  </Text>
));
const certificateHeadlineText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.certificateHeadlineStyle, ...otherProps.style, }}>
    {children}
  </Text>
));
const disputeCountText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.disputeCountTextStyle, ...otherProps.style, }}>
    {children}
  </Text>
));
const closurePolicyText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.closurePolicyText, ...otherProps.style, }}>
    {children}
  </Text>
));
const fontBrown = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.fontBrown, ...otherProps.style, }}>
    {children}
  </Text>
));
//loginStyle
const loginText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.loginText, ...otherProps.style }}>{children}</Text>
));

const signInText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.signInText, ...otherProps.style }}>{children}</Text>
));
const labelStyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.labelStyle, ...otherProps.style }}>{children}</Text>
));
const textStyleForgot = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.textStyleForgot, ...otherProps.style }}>{children}</Text>
));

const loginBtmText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.loginBtmText, ...otherProps.style }}>{children}</Text>
));

const loginHereText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.loginHereText, ...otherProps.style }}>{children}</Text>
));


const captchaText = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.captchaText, ...otherProps.style }}>{children}</Text>
));
const enterOtpDescStyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.enterOtpDescStyle, ...otherProps.style }}>{children}</Text>
));
const checkTaglabelStyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.checkTaglabelStyle, ...otherProps.style }}>{children}</Text>
));
const enterOtpTxtStyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.enterOtpTxtStyle, ...otherProps.style }}>{children}</Text>
));

const activeCapchaStyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.activeCapchaStyle, ...otherProps.style }}>{children}</Text>
));
const forgetPwHeader = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.forgetPwHeader, ...otherProps.style }}>{children}</Text>
));

const tagBalanceDescStyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.tagBalanceDescStyle, ...otherProps.style }}>{children}</Text>
));
const tagBalanceAmountStyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.tagBalanceAmountStyle, ...otherProps.style }}>{children}</Text>
));
const checkOtpDesc = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.checkOtpDesc, ...otherProps.style }}>{children}</Text>
));
const checkTagSubmitStyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.checkTagSubmitStyle, ...otherProps.style }}>{children}</Text>
));
const helperTxtErrorStyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.helperTxtErrorStyle, ...otherProps.style }}>{children}</Text>
));

const forgetPw = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.forgetPw, ...otherProps.style }}>{children}</Text>
));

const forgetNewPw = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.forgetNewPw, ...otherProps.style }}>{children}</Text>
));

const helperTxtStyle = React.memo(({ children, ...otherProps }) => (
  <Text style={{ ...styles.helperTxtStyle, ...otherProps.style }}>{children}</Text>
));



const vrnText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.vrnTextStyle, ...otherProps.style, }}> {children} </Text>));
const vehicleModal = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.vehicleModalStyle, ...otherProps.style, }}> {children} </Text>));
const priceText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.priceTextStyle, ...otherProps.style, }}> {children} </Text>));
const headerText= React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.headerTextStyle, ...otherProps.style, }}> {children} </Text>));
const dropDownHeaderText= React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.dropDownHeaderTextStyle, ...otherProps.style, }}> {children} </Text>));
const inputLabelText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.inputLabelStyle, ...otherProps.style, }}> {children} </Text>));
const tagWarningText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.tagWarningTextStyle, ...otherProps.style, }}> {children} </Text>));
const tagWarningDesc = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.tagWarningDescStyle, ...otherProps.style, }}> {children} </Text>));
const warningHeader = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.warningHeaderStyle, ...otherProps.style, }}> {children} </Text>));
const searchText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.searchTextStyle, ...otherProps.style, }}> {children} </Text>));
const modalTitle = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.modalTitleStyle, ...otherProps.style, }}> {children} </Text>));
const modalMsg = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.modalMsgStyle, ...otherProps.style, }}> {children} </Text>));
const modalFooterLink = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.modalFooterLinkStyle, ...otherProps.style, }}> {children} </Text>));
const newText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.newTextStyle, ...otherProps.style, }}> {children} </Text>));
const paymentLogoText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.paymentLogoTextStyle, ...otherProps.style, }}> {children} </Text>));
const autoRechargeText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.AutoRechargeTextStyle, ...otherProps.style, }}> {children} </Text>));
const autoRechargeTextDesc = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.AutoRechargeTextDescStyle, ...otherProps.style, }}> {children} </Text>));
const fundTransferText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.FundTransferTextStyle, ...otherProps.style, }}> {children} </Text>));
const fundTransferTextDesc = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.FundTransferTextDescStyle, ...otherProps.style, }}> {children} </Text>));
const vehicleNbr = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.vehicleNbrStyle, ...otherProps.style, }}> {children} </Text>));
const rupeeSymbol = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.rupeeSymbolStyle, ...otherProps.style, }}> {children} </Text>));
const enterOtpText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.enterOtpTextStyle, ...otherProps.style, }}> {children} </Text>));
const otpDescText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.otpDescTextStyle, ...otherProps.style, }}> {children} </Text>));
const timerText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.timerTextStyle, ...otherProps.style, }}> {children} </Text>));
const resendText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.resendTextStyle, ...otherProps.style, }}> {children} </Text>));
const bulletText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.bulletTextStyle, ...otherProps.style, }}> {children} </Text>));
const verifyText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.verifyTextStyle, ...otherProps.style, }}> {children} </Text>));
const verifiedText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.verifiedTextStyle, ...otherProps.style, }}> {children} </Text>));
const mpDetailsText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.mpdetailsText, ...otherProps.style, }}> {children} </Text>));
const mpDetailsLink = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.mpdetailsLink, ...otherProps.style, }}> {children} </Text>));
const mpLowbalance = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.mpLowbalance, ...otherProps.style, }}> {children} </Text>));
const mpMinbalance = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.mpMinbalance, ...otherProps.style, }}> {children} </Text>));
const mpHeaderText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.mpHeaderTextStyle, ...otherProps.style, }}> {children} </Text>));
const mpbenefitText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.mpbenefitTextStyle, ...otherProps.style, }}> {children} </Text>));
const mpTitleText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.mpTitleTextStyle, ...otherProps.style, }}> {children} </Text>));
const mpTitleTextYellow = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.mpTitleTextStyleYellow, ...otherProps.style, }}> {children} </Text>));
const mpTextYellow = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.mpTextStyleYellow, ...otherProps.style, }}> {children} </Text>));
const mpTermsText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.mpTermsTextStyle, ...otherProps.style, }}> {children} </Text>));
const mpYearText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.mpYearTextStyle, ...otherProps.style, }}> {children} </Text>));
const mpHeaderDesc = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.mpHeaderDescStyle, ...otherProps.style, }}> {children} </Text>));
const ucltandcItSm = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.ucltandcItSm, ...otherProps.style }}>{children}</Text>));
const ucltandcBold = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.ucltandcBold, ...otherProps.style }}>{children}</Text>));
const optOutConfirmText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.optOutConfirmTextStyle, ...otherProps.style }}>{children}</Text>));
const tncText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.tncTextStyle, ...otherProps.style }}>{children}</Text>));
const tripInsRefText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.tripInsRefTextStyle, ...otherProps.style }}>{children}</Text>));
const tripInsPlanDesc = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.tripInsPlanDescStyle, ...otherProps.style }}>{children}</Text>));
const updateKycText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.updateKycTextStyle, ...otherProps.style }}>{children}</Text>));
const srDate = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.srDateStyle, ...otherProps.style }}>{children}</Text>));
const srStatus = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.srStatusStyle, ...otherProps.style }}>{children}</Text>));
const srReqId = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.srReqIdStyle, ...otherProps.style }}>{children}</Text>));
const selectedChasisText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.selectedChasisTextStyle, ...otherProps.style }}>{children}</Text>));
const fastagIdText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.fastagIdTextStyle, ...otherProps.style }}>{children}</Text>));
const changeVehicleText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.changeVehicleTextStyle, ...otherProps.style }}>{children}</Text>));
const creditCardTitle = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.creditCardTitleStyle, ...otherProps.style }}>{children}</Text>));
const cardNumber = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.cardNumberStyle, ...otherProps.style }}>{children}</Text>));
const editText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.editTextStyle, ...otherProps.style }}>{children}</Text>));
const selectNumberText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.selectNumberTextStyle, ...otherProps.style }}>{children}</Text>));
const creditCardText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.creditCardTextStyle, ...otherProps.style }}>{children}</Text>));
const maskedCardNumber = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.maskedCardNumberStyle, ...otherProps.style }}>{children}</Text>));
const closeText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.closeTextStyle, ...otherProps.style }}>{children}</Text>));
const selecARText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.selecARTextStyle, ...otherProps.style }}>{children}</Text>));
const updateText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.updateTextStyle, ...otherProps.style }}>{children}</Text>));
const getOtpText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.getOtpTextStyle, ...otherProps.style }}>{children}</Text>));
const adrsText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.adrsTextStyle, ...otherProps.style }}>{children}</Text>));
const updatePicText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.updatePicTextStyle, ...otherProps.style }}>{children}</Text>));
const tranxnText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.tranxnTextStyle, ...otherProps.style }}>{children}</Text>));
const smsText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.smsTextStyle, ...otherProps.style }}>{children}</Text>));
const welcomeModalDesc = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.welcomeModalDescText, ...otherProps.style }}>{children}</Text>));
const welcomeModalTitle = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.welcomeModalTitle, ...otherProps.style }}>{children}</Text>));
const npciMarkedTitle = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.npciMarkedTitleStyle, ...otherProps.style }}>{children}</Text>));
const npciMarkedDesc = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.npciMarkedDescStyle, ...otherProps.style }}>{children}</Text>));
const npciMarkedVehListTitle = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.npciMarkedVehListTitleStyle, ...otherProps.style }}>{children}</Text>));
const npciMarkedVehListDesc = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.npciMarkedVehListDescStyle, ...otherProps.style }}>{children}</Text>));
const markedForCloseText = React.memo(({ children, ...otherProps }) => (<Text style={{ ...styles.markedForCloseTextStyle, ...otherProps.style }}>{children}</Text>));





export default {
  inputLabel,
  inputError,
  otpTitle,
  otpDesc,
  otherServicesTitle,
  usedCarLoanHeader,
  usedCarLoanIntro,
  usedCarLoanUpto,
  basicInformation,
  basicInformationSubHeader,
  headerDesc,
  inputTopLabel,
  backNavigationText,
  statusTitle,
  serviceDesc,
  kycDesc,
  kycTypeText,
  tripBenifitText,
  loanAppCardTitleText,
  loanAppCardIdValueText,
  loanAppCardStatusValueText,
  certificateText,
  transactionText,
  historyText,
  policyNbrText,
  mobileDescText,
  inputNoteText,
  benifitHeaderText,
  benifitText,
  benifitPlanHeadingText,
  cancelPolicyConfirmText,
  tiTransactionText,
  certificateHeadlineText,
  disputeCountText,
  closurePolicyText,
  fontBrown,
  vrnText,
  vehicleModal,
  priceText,
  headerText,
  dropDownHeaderText,
  inputLabelText,
  tagWarningText,
  tagWarningDesc,
  warningHeader,
  searchText,
  modalTitle,
  modalMsg,
  modalFooterLink,
  paymentLogoText,
  newText,
  autoRechargeText,
  autoRechargeTextDesc,
  fundTransferText,
  fundTransferTextDesc,
  vehicleNbr,
  rupeeSymbol,
  enterOtpText,
  otpDescText,
  timerText,
  resendText,
  bulletText,
  verifyText,
  verifiedText,
  mpDetailsText,
  mpDetailsLink,
  mpLowbalance,
  mpMinbalance,
  mpHeaderText,
  mpbenefitText,
  mpTitleText,
  mpTitleTextYellow,
  mpTextYellow,
  mpTermsText,
  mpYearText,
  mpHeaderDesc,
  ucltandcItSm,
  ucltandcBold,
  sideNavTextActive, 
  sideNavText,
  optOutConfirmText,
  tncText,
  tripInsRefText,
  tripInsPlanDesc,
  updateKycText,
  tripInsPlanDesc,
  srDate,
  srStatus,
  srReqId,
  loginText,
  signInText,
  labelStyle,
  textStyleForgot,
  captchaText,
  // loginBtmText,
  // loginHereText,
  enterOtpDescStyle,
  activeCapchaStyle,
  enterOtpTxtStyle,
  checkTaglabelStyle,
  checkTagSubmitStyle,
  checkOtpDesc,
  tagBalanceDescStyle,
  tagBalanceAmountStyle,
  forgetPwHeader,
  forgetNewPw,
  forgetPw,
  helperTxtErrorStyle,
  helperTxtStyle,
  PoolEditBtn,
  CCardStyle,
  MaskCard,
  viewVehicleTextStyle,
  headingTextStyle,
  cardNUmberTextStyle,
  poolAcTextStyle,
  amountTextStyle,
  qabInnerText,
  PoolText,
  paymentMethodTextStyle,maskedCardNumber,closeText,selecARText,updateText,getOtpText,adrsText,updatePicText,tranxnText,smsText,
  selectCCstyle,selectedChasisText,fastagIdText,changeVehicleText,creditCardTitle,cardNumber,editText,selectNumberText,creditCardText,
  welcomeModalDesc,welcomeModalTitle,npciMarkedTitle,npciMarkedDesc, npciMarkedVehListTitle, npciMarkedVehListDesc, markedForCloseText
};
